<template>
  <!-- 右侧列表相关链接 -->
  <div class="card-right">
    <el-card shadow="never" style="width: 332px; height: 80vh">
      <div class="right-list">
        <div class="list-title" style="margin-bottom: 10px">
          <h3 style="color: #a19b5a">| 相关列表快速链接</h3>
        </div>
        <el-menu class="menu-border">
          <el-menu-item @click="goToExamineIntegrate" style="border: 1px solid #ccc">
            <span slot="title">积分明细</span>
          </el-menu-item>
          <el-menu-item @click="goToExamineRecommend" style="border: 1px solid #ccc; border-top: 0">
            <span slot="title">推荐会员清单</span>
          </el-menu-item>
          <el-menu-item @click="goToExamineSales" style="border: 1px solid #ccc">
            <span slot="title">陪同购买销售单</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "GiadaRightcard",
  props: ["GFCrmID"],
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goToExamineIntegrate() {
      // this.$router.push("/ExamineIntegrate");
      this.$router.push({
        path: "/ExamineIntegrate",
        query: {
          custID: this.GFCrmID,
        },
      });
    },
    goToExamineRecommend() {
      // this.$router.push("/ExamineRecommend");
      this.$router.push({
        path: "/ExamineRecommend",
        query: {
          custID: this.GFCrmID,
        },
      });
    },
    goToExamineSales() {
      // this.$router.push("/ExamineSales");
      this.$router.push({
        path: "/ExamineSales",
        query: {
          custID: this.GFCrmID,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  /* 改变elementui 侧边栏移入颜色 */
  .el-menu-item:hover {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-submenu__title:hover {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-menu-item.is-active {
    background: #f5f3e0;
    color: #6c6839;
  }
  .el-submenu__title.is-active {
    background: #f5f3e0;
    color: #6c6839;
  }
}
</style>
